import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

var marked = require('marked');
marked.setOptions({
  gfm: true,
  tables: true,
  breaks: true,
  sanitize: true
});

import People_Item from '../components/People_Item';
import Container from '../components/Shared/Container';
import InnerContainer from '../components/Shared/InnerContainer';
import SectionHeader from '../components/Shared/SectionHeader';
import SectionText from '../components/Shared/SectionText';

import AmyImage from '../images/amy.jpg';

const PeoplePage = ({data}) => (
  <div style={{ minHeight: '100vh'}}>
    {/* <About_Section /> */}
    <Container people>
      <InnerContainer light>
        <SectionHeader light>
          About Me
        </SectionHeader>
        <FlexRow>
          <AboutImage src={AmyImage} />
          <SectionText style={{ flex: '1'}} dangerouslySetInnerHTML={ {__html:
            marked(data.allContentfulPage.edges[0].node.mainText.body.body,
            {sanitize: true})}}
          />
        </FlexRow>
      </InnerContainer>
    </Container>
    {/* {data.allContentfulPage.edges[0].node.featuredItems &&
      <Container>
        <InnerContainer>
          <SectionHeader>Current Students</SectionHeader>
          <FlexContainer>
            {data.allContentfulPage.edges[0].node.featuredItems &&
              data.allContentfulPage.edges[0].node.featuredItems.map((item, i) => {
              return (<People_Item key={i} person={item} />)
            })}
          </FlexContainer>
        </InnerContainer>
      </Container>
    } */}
    <Container grey>
      <InnerContainer>
        <SectionHeader>Former Students</SectionHeader>
        <FlexContainer>
          {data.allContentfulPage.edges[0].node.additionalItems &&
            data.allContentfulPage.edges[0].node.additionalItems.map((item, i) => {
            return (<People_Item key={i} person={item} />)
          })}
        </FlexContainer>
      </InnerContainer>
    </Container>
  </div>
)

export default PeoplePage;

export const query = graphql`
  query PeopleQuery {
    allContentfulPage
      (
        filter:{
          title: {
            eq: "People"
          }
        }
      )
    {
      edges {
        node {
          title
          mainText {
            body {
              body
            }
          }
          featuredItems {
            ... on ContentfulPerson {
              name
              position
              institution
              year
              description {
                description
              }
              image {
                file {
                  url
                }
              }
            }
          }
          additionalItems {
            ... on ContentfulPerson {
              name
              position
              institution
              year
              description {
                description
              }
              image {
                file {
                  url
                }
              }
            }
          }
        }
      }
    }
    # allContentfulPerson (
    #   sort: { fields: [year], order: DESC }
    # ) {
    #   edges {
    #     node {
    #       name
    #       institution
    #       year
    #       position
    #       description {
    #         description
    #       }
    #     }
    #   }
    # }
  }
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 650px) {
    flex-direction: column;
    align-items: center;
  }
`;

const AboutImage = styled.div`
  height: 300px;
  width: 300px;
  margin: 8px 20px 0 0;
  background: ${props =>
    props.src && `url(${props.src})`
  };
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @media (max-width: 900px) {
    margin: 8px 20px 0 0;
    max-height: 300px;
    width: 200px;
  };
  @media (max-width: 650px) {
    width: 100%;
    margin: 0 0 20px;
  };
`;

// const Container = styled.div`
//   background-color: #eee;
//   flex-direction: column;
//   justify-content: center;
//   padding: 40px 10px;
//   min-height: 100vh;
//   font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
// `;
//
// const InnerContainer = styled.div`
//   max-width: 960px;
//   margin: auto;
//   padding: 20px;
//   color: #333;
// `;
//
// const SectionHeader = styled.h1`
//   text-align: center;
//   font-weight: 300;
// `;



// WEBPACK FOOTER //
// ./src/pages/people.js